export const CenterNoticeStatus = {
  PENDING: '대기',
  ISSUED: '노출',
  EXPIRED: '마감',
} as const;
